import { createStyles } from "@mantine/core";
import { colors, pxToRem } from "theme";

type CreateStylesProp = {
  isInErrorState: boolean;
};

export const useStyles = createStyles((_theme, { isInErrorState }: CreateStylesProp) => ({
  offerContainer: {
    backgroundColor: colors.grey[3],
    borderRadius: "3px",
  },
  counterOffer: {
    fontWeight: 500,
  },
  input: {
    border: "none",
    height: "72px",
    fontWeight: 400,
    fontSize: "48px",
    lineHeight: "56px",
    textAlign: "center",
    color: isInErrorState ? colors.red[50] : colors.grey[90],
    "&::placeholder": {
      paddingLeft: "32px",
    },
  },
  rightSection: {
    alignItems: "end",
    bottom: pxToRem[10],
    width: "auto",
  },
  errorWrapper: {
    visibility: isInErrorState ? "visible" : "hidden",
  },
  errorIcon: {
    marginTop: pxToRem[4],
    marginRight: pxToRem[6],
  },
  errorText: {
    color: colors.red[50],
  },
}));
